import React from 'react';
import { Wrench } from 'lucide-react';

const WorkTypes = ({ t }) => {
  return (
    <section className="work-types-section">
      <div className="container">
        <h2 className="section-title">{t.workTypes.title}</h2>
        
        <div className="work-types-grid">
          {t.workTypes.items.map((item, index) => (
            <div key={index} className="work-type-card">
              <Wrench size={24} className="work-type-icon" />
              <p className="work-type-text">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkTypes;